export default __webpack_public_path__ + "static/media/icon-report-print.f3f04722.svg";